import FieldWrapper from "../components/FieldWrapper";
import { TextFieldType } from "../types/feedbackFields.types";

const TextField = ({ field }: { field: TextFieldType }) => {
  return (
    <FieldWrapper field={field} showLabel={false}>
      {field.textHtml && <div dangerouslySetInnerHTML={{ __html: field.textHtml }} />}
      {!field.textHtml && <div>{field.text}</div>}
    </FieldWrapper>
  );
};
export default TextField;
